const PluginModel = function () {
    return {
        "name": "",
        "slug": "",
        "token": "",
        "client": "",
        "version": "",
        "description": "",
        "params": {},
        "key": "",
        "callbacks": []
    }
}
export default PluginModel